import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { functionCtaType } from '@app/finxone-web-frontend/app/lib/utils/cta-button-actions/cta-button-actions.utils';
import {
  ActionButtonOutcomesType,
  ButtonActionType,
  DocumentActionType,
  UiZoneWidgetAttributeConfig,
} from '@finxone-platform/shared/sys-config-types';
import { createRedirectionUrlFromNavigationOptions } from '../utils';
import { secureDocumentUploadAction } from './document-actions/secure-document-upload-action';
import { downloadDocumentFile } from './generic-actions/download-document.utils';
import {
  deleteTransactionReceipt,
  uploadTransactionReceipt,
} from './transaction-receipt/transaction-receipt';

export const documentActions: Map<ButtonActionType, functionCtaType> = new Map([
  [
    ButtonActionType.DELETE_DOCUMENT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      if (attri.widgetProperties?.documentActionType === DocumentActionType.TRANSACTIONS) {
        deleteTransactionReceipt(injector, attri);
      }
    },
  ],
  [
    ButtonActionType.UPLOAD_DOCUMENT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      if (attri.widgetProperties?.documentActionType === DocumentActionType.TRANSACTIONS) {
        uploadTransactionReceipt(injector, attri);
      }
    },
  ],
  [
    ButtonActionType.VIEW_DOCUMENT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      if (attri.widgetProperties?.documentActionType === DocumentActionType.TRANSACTIONS) {
        viewDocumentRedirection(injector, attri);
      }
    },
  ],
  [
    ButtonActionType.REPLACE_DOCUMENT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      if (attri.widgetProperties?.documentActionType === DocumentActionType.TRANSACTIONS) {
        uploadTransactionReceipt(injector, attri);
      }
    },
  ],
  [
    ButtonActionType.DOWNLOAD_DOCUMENT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      downloadDocumentFile(injector, attri);
    },
  ],
  [
    ButtonActionType.SECURE_DOCUMENT_UPLOAD,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      secureDocumentUploadAction(injector, attri);
    },
  ],
]);

export function handleFileUpload(acceptTypes: string, onChangeCallback: (file: File | null) => void) {
  const fileInput = document.createElement('input');
  fileInput.type = 'file';
  fileInput.accept = acceptTypes;

  fileInput.onchange = (event: Event) => {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0] ?? null;
    onChangeCallback(file);
    fileInput.remove(); // Clean up after selection or cancellation
  };

  fileInput.click();
}

//Redirection to view Document page
export function viewDocumentRedirection(injector: Injector, attri: UiZoneWidgetAttributeConfig) {
  const navigationConfig = attri.widgetProperties?.['actionNavigationConfigurations'];
  const router = injector.get(Router);
  if (navigationConfig?.[ActionButtonOutcomesType.SUCCESS]) {
    const redirectUrl = createRedirectionUrlFromNavigationOptions(
      navigationConfig[ActionButtonOutcomesType.SUCCESS],
    );
    router.navigateByUrl(redirectUrl);
  }
}

export function downloadFile(fileUrl: string, name: string) {
  const fileExtension = new URL(fileUrl).pathname.split('.').pop();
  const fileName = `${name}-${new Date().getTime()}.${fileExtension}`;

  fetch(fileUrl)
    .then((response) => response.blob())
    .then((blob) => {
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    })
    .catch((error) => {
      console.error('Download failed:', error);
    });
}
